import React from 'react'
import PropTypes from 'prop-types'
import TextBox from 'components/common/text_box'
import { getDefaultCurrencyCode } from 'client/griffin'

class MoneyTextBox extends React.Component {
  static propTypes = {
    disableCents: PropTypes.bool,
    currencyCode: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }

  render() {
    let { value } = this.props
    let currencyCode = this.props.currencyCode || getDefaultCurrencyCode()

    let { ...propsToPass } = this.props
    delete propsToPass.styles

    return (
      <TextBox
        currencyCode={currencyCode}
        decimalDigits={this.props.disableCents ? 0 : null} // null here means use the currency's decimal digits
        removeTrailingZeros={this.props.disableCents}
        {...propsToPass}
        value={value}
      />
    )
  }
}

export default MoneyTextBox
